export default "__VITE_ASSET__CMG49orU__"